<template>
  <div class="clickable">
    <img class="flagged-img" :src="getFlagUrl()" @click="$emit('flag-toggle')"/>
  </div>
</template>

<script>
import './user-notifications.scss'


export default {
  name: "notification-flag.vue",
  props: ["flagged"],
  methods: {
    getFlagUrl () {
      let color = this.flagged ? "red" : "gray";
      return `/images/notifications/flag_${color}.svg`;
    }
  }
};
</script>
